import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    error: false,
    errorMessage: "",
    errorType: "",
    preScreenForm: {}
};


// fetch the all primary diagnosis list 
export const fetchPrimaryDiagnosis = createAsyncThunk(
    'bmr/fetchPrimaryDiagnosis',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/primary-diagnosis/list');
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);

// fetch the all primary diagnosis list 
export const addPreScreenForm = createAsyncThunk(
    'bmr/addPreScreenForm',
    async (args, { rejectWithValue }) => {
        try {
            const { data } = args
            const response = await api.post('/create-prescreen-form', data);
            notify.success(response?.data?.message);
            return response?.data;
        } catch (error) {
            notify.error(error || error?.message || error?.response || error?.response?.data)
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);

// updatePreScreenForm
export const updatePreScreenForm = createAsyncThunk(
    'bmr/updatePreScreenForm',
    async (args, { rejectWithValue }) => {
        try {
            const { data, id } = args
            const response = await api.put(`/update-prescreen-form/${id}`, data);
            notify.success(response?.data?.message);
            return response?.data;
        } catch (error) {
            notify.error(error?.message || error?.response || error?.response?.data || error)
            return rejectWithValue(error?.response ? error?.response?.data : error?.message ? error?.message : error);
        }
    }
);


// uploadFiles
export const uploadFiles = createAsyncThunk(
    'bmr/uploadFiles',
    async (args, { rejectWithValue }) => {
        try {
            const { data, id } = args
            const response = await api.post(`/s3-upload/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'multipart/form-data'
                }
            });
            notify.success(response?.data?.message);
            return response?.data;
        } catch (error) {
            notify.error(error || error?.message || error?.response || error?.response?.data)
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);

// uploadFiles Public
export const uploadFilesPublic = createAsyncThunk(
    'bmr/uploadFiles',
    async (args, { rejectWithValue }) => {
        try {
            const { data } = args
            const response = await api.post(`/s3/upload/public`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'multipart/form-data'
                }
            });
            notify.success(response?.data?.message);
            return response?.data;
        } catch (error) {
            notify.error(error || error?.message || error?.response || error?.response?.data);
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);

// fetch the details for pre screen form
export const fetchDetailsPreScreen = createAsyncThunk(
    'bmr/fetchDetailsPreScreen',
    async (preScreenId, { rejectWithValue }) => {
        try {
            const response = await api.get(`/prescreen/${preScreenId}/details`);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);

// deleteFiles
export const deleteFile = createAsyncThunk(
    'bmr/deleteFile',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/s3-delete/${id}`);
            notify.success(response?.data?.message);
            return response?.data;
        } catch (error) {
            notify.error(error || error?.message || error?.response || error?.response?.data)
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);


const bmrAppointmentSlice = createSlice({
    name: 'bmrAppointment',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        /// handle fetch all primary diagnosis list
        builder
            .addCase(fetchPrimaryDiagnosis.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPrimaryDiagnosis.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchPrimaryDiagnosis.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle fetch all primary diagnosis list
        builder
            .addCase(addPreScreenForm.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addPreScreenForm.fulfilled, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message
                state.errorType = "success"
                state.error = true
            })
            .addCase(addPreScreenForm.rejected, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message;
                state.errorType = "error"
                state.error = true
            });
        /////updatePreScreenForm
        builder
            .addCase(updatePreScreenForm.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePreScreenForm.fulfilled, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message
                state.errorType = "success"
                state.error = true
            })
            .addCase(updatePreScreenForm.rejected, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message;
                state.errorType = "error"
                state.error = true
            });
        /// handle fetch all primary diagnosis list

        builder
            .addCase(fetchDetailsPreScreen.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchDetailsPreScreen.fulfilled, (state, action) => {
                state.isLoading = false;
                state.preScreenForm = action.payload.data
            })
            .addCase(fetchDetailsPreScreen.rejected, (state) => {
                state.isLoading = false;
                state.preScreenForm = {}
            });
        /// handle uploadFiles 

        builder
            .addCase(uploadFiles.pending, (state) => {
                state.isLoading = false;
            })
            .addCase(uploadFiles.fulfilled, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message
                state.errorType = "success"
                state.error = true
            })
            .addCase(uploadFiles.rejected, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action.payload?.message ?? "";
                state.errorType = "error"
                state.error = true
            });
        /// handle deleteFilesd 

        builder
            .addCase(deleteFile.pending, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteFile.fulfilled, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message
                state.errorType = "success"
                state.error = true
            })
            .addCase(deleteFile.rejected, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message;
                state.errorType = "error"
                state.error = true
            });
    },
});
export const selectbmrAppointmentLoading = (state) => state.bmrAppointment.isLoading;
export const selectbmrPreScreenDetails = (state) => state.bmrAppointment.preScreenForm;









export default bmrAppointmentSlice.reducer;
